<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table 
            :headers="headers"
            :items="issues"
            :search="search"
            sort-by="calories"
            class="elevation-1"
            >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Assembly: Issue Notification</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>                    
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <v-spacer></v-spacer>                   
                     
                        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                            <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">New</v-btn>
                            </template>
                            <v-card>
                                <v-toolbar dark color="primary">
                                    <v-btn icon dark @click="dialog = false">
                                    <v-icon>close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>                                    
                                    
                                                <v-btn
                                                :disabled="dialogLoading"
                                                :loading="dialogLoading"
                                                class="white--text"
                                                dark text
                                                 @click="save"
                                                >
                                                Save
                                                </v-btn>

                                                <v-dialog
                                                v-model="dialogLoading"
                                                hide-overlay
                                                persistent
                                                width="300"
                                                >
                                                <v-card
                                                    color="primary"
                                                    dark
                                                >
                                                    <v-card-text>
                                                    Saving, please be patient.
                                                    <v-progress-linear
                                                        indeterminate
                                                        color="white"
                                                        class="mb-0"
                                                    ></v-progress-linear>
                                                    </v-card-text>
                                                </v-card>
                                                </v-dialog>
                                          <!--  </div>
                                        </template>-->                                          
                                    
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-expansion-panels popout multiple  focusable>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Issue Information
                                            <template v-slot:actions>
                                                <v-icon color="error">error</v-icon>
                                            </template>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                             <v-card>                                
                                                <v-card-text>
                                                    <v-container>
                                                        <v-row>
                                                            <v-col cols="12" sm="6" md="2">
                                                                <v-flex xs12 sm12 md12 lg12 xl12>
                                                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">
                                                                    </div>
                                                                </v-flex>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>                                                            
                                                            <v-col cols="12" sm="6" md="2">
                                                            <v-text-field v-model="partNo" label="Part Number"></v-text-field>
                                                            </v-col>                                         
                                                            <v-col cols="12" sm="6" md="2">
                                                            <v-text-field type = "number" v-model.number="commodity" label="Commodity"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="2">
                                                            <v-text-field type = "number" v-model.number="good" label="Good"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="2">
                                                            <v-text-field type = "number" v-model.number="ng" label="NG"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="2">
                                                            <v-text-field type = "number" v-model.number="fr" label="FR"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="12">
                                                            <v-text-field v-model="defectDescription" label="Description"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="3">
                                                            <v-text-field v-model="lob" label="LOB"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="3">
                                                            <v-text-field v-model="platform" label="Plat Form"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="3">
                                                            <v-text-field v-model="batch" label="Batch"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="3">
                                                            <v-text-field v-model="lineName" label="Line"></v-text-field>
                                                            </v-col>                                                
                                                        </v-row>
                                                    </v-container>
                                                </v-card-text>          
                                            </v-card>
                                        </v-expansion-panel-content>                                        
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Take a Picture
                                            <template v-slot:actions>
                                                <v-icon >add_a_photo</v-icon>
                                            </template>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <GetPicture @clicked="takePicture"  :imgBase64="imgBase64"></GetPicture> 
                                        </v-expansion-panel-content>                                        
                                    </v-expansion-panel>
                                </v-expansion-panels>                               
                            </v-card>
                            </v-dialog>                       
                    
                    </v-toolbar>
                </template>
               
                
               
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.issueID">
                        <td >
                        <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                                >
                                edit
                                </v-icon>  
                                <v-icon
                                small
                                @click="deleteItem(item)"
                                >
                                delete
                                </v-icon>         
                                </td>                  
                            <td class="text-xs-right">{{item.issueID}} </td>                            
                            <td class="text-xs-right">{{item.lineName}} </td>
                            <td class="text-xs-right">{{item.commodity}} </td>
                            <td class="text-xs-right">{{item.good}} </td>
                            <td class="text-xs-right">{{item.defectDescription}} </td>                                
                            
                            <td class="text-xs-right">{{item.callOuts}} </td> 
                            <td class="text-xs-right">
                                <div v-if="item.owner=='Pending'">
                                    <span class="orange--text">{{item.owner}}</span>
                                </div>
                                <div v-else="item.owner=='Pending'">
                                    {{item.owner}} 
                                </div>
                            </td>
                           
                            <td class="text-xs-right">                       
                                <div v-if="item.status=='Open'">                               
                                    <span class="red--text"><SetInterval :createDate="item.createDate"></SetInterval> </span>
                                </div>
                                <div v-if="item.status=='On Going'">
                                    <span >{{item.status}} </span>
                                </div>
                                <div v-if="item.status=='Completed'">
                                    {{item.status}} 
                                </div>
                                <div v-if="item.status=='Close'">
                                    <span class="blue--text">{{item.status}} </span>
                                </div>
                            </td>

                        </tr>
                    </tbody>
                </template>
                     
                
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
    </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
    import GetPicture from './AppCamara/GetPicture'; 
    import SetInterval from './SetInterval';   
    import axios from 'axios';   
   
    export default{
        components: {
            GetPicture,
            SetInterval            
        },
       
        data (){
            return {
                  issues:[],                  
                  dialog: false,
                  dialogLoading: false,
                    headers: [
                        { text: 'Actions', value: 'action', sortable: false },
                        { text: 'Folio', value: 'issueID', sortable: false },
                        { text: 'Line', value: 'lineName', sortable: false },
                        { text: 'Commodity', value: 'commodity', sortable: false },
                        { text: 'Good', value: 'good', sortable: false },
                        { text: 'Desc', value: 'defectDescription', sortable: false },
                        { text: 'Call Outs', value: 'callOuts', sortable: false },
                        { text: 'Owner', value: 'owner', sortable: false },
                        { text: 'Status', value: 'status', sortable: true }                              
                    ],
                    //moment: moment, // Set to whatever
                    search: '',
                    desserts: [],
                    editedIndex: -1,
                    editedItem: {
                        name: '',
                        calories: 0,
                        fat: 0,
                        carbs: 0,
                        protein: 0,
                    },
                    id: '', 
                    lineName: '',                  
                    partNo: '',
                    commodity: 0,                    
                    batch: '',
                    platform: '',
                    lob: '',
                    good: 0,
                    ng: 0,
                    fr: 0, 
                    defectDescription: '',               
                    IPQC_Is_Issue: true,
                    IPQC_Comments: '',
                    callOuts: 'IPQC',
                    owner: 'Pending',
                    status: 'Open',
                    currentCall: '',
                    condition: '',                    
                    creator : 'RAFBEL',
                    updaterDate: '',
                    updater: '',                  
                    
                    imgBase64: '',

                    issueDetails: [],
                    issuePictures: [],

                    valida:0,
                    validaMensaje:[]   
                                
            }   
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Issue' : 'Edit Issue'
            },            
        },

        watch: {
            dialog (val) {
            val || this.close()
            },
            dialogLoading (val)  {
                if (!val) return
            }        
        },

        created () {
            this.initialize();
            this.listIssues();
                    
        },

         methods: {
            takePicture (value) {
                this.imgBase64 = value;
            },
            listIssues(){
                let me=this;
                let header={"Authorization": "Bearer " + this.$store.state.token};
                let configuration = {headers : header };
                axios.get('api/Issues/List',configuration).then(function(response){
                    //console.log(response);
                    me.issues = response.data;
                }).catch(function(error){
                    console.log(error);
                })
            },
            
            initialize () {
            this.desserts = [
                {
                name: 'Frozen Yogurt',
                calories: 159,
                fat: 6.0,
                carbs: 24,
                protein: 4.0,
                },
                {
                name: 'Ice cream sandwich',
                calories: 237,
                fat: 9.0,
                carbs: 37,
                protein: 4.3,
                },
                {
                name: 'Eclair',
                calories: 262,
                fat: 16.0,
                carbs: 23,
                protein: 6.0,
                },
                {
                name: 'Cupcake',
                calories: 305,
                fat: 3.7,
                carbs: 67,
                protein: 4.3,
                },
                {
                name: 'Gingerbread',
                calories: 356,
                fat: 16.0,
                carbs: 49,
                protein: 3.9,
                },
                {
                name: 'Jelly bean',
                calories: 375,
                fat: 0.0,
                carbs: 94,
                protein: 0.0,
                },
                {
                name: 'Lollipop',
                calories: 392,
                fat: 0.2,
                carbs: 98,
                protein: 0,
                },
                {
                name: 'Honeycomb',
                calories: 408,
                fat: 3.2,
                carbs: 87,
                protein: 6.5,
                },
                {
                name: 'Donut',
                calories: 452,
                fat: 25.0,
                carbs: 51,
                protein: 4.9,
                },
                {
                name: 'KitKat',
                calories: 518,
                fat: 26.0,
                carbs: 65,
                protein: 7,
                },
            ]
            },

            editItem (item) {
                //this.editedIndex = this.desserts.indexOf(item)
                //this.editedItem = Object.assign({}, item)
                this.id = item.issueID;
                                
                this.partNo = item.partNo;
                this.commodity = item.commodity;
                this.good = item.good;
                this.ng = item.ng;
                this.fr = item.fr; 

                this.defectDescription = item.defectDescription;
                
                this.lob = item.lob;
                this.platform = item.platform;
                this.batch = item.batch;
                this.lineName = item.lineName;  
                this.updater = 'RAFBEL';
               
                //this.IPQC_Is_Issue = item.IPQC_Is_Issue;
                //this.IPQC_Comments = item.iPQC_Comments;
                //this.callOuts = item.callOuts;
                //this.owner = item.owner;
                //this.status = item.status;
                //this.currentCall = item.currentCall;
                //this.condition = item.condition;                
                //this.creator = item.creator;
                //this.updaterDate = item.updaterDate;
                //this.updater = item.updater; 

                //this.imgBase64 = "";     
                
                //this.issueDetails= [];
                //this.issuePictures= [];

                this.editedIndex=1;
                this.dialog = true
            },

            deleteItem (item) {
                const index = this.desserts.indexOf(item)
                confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
            },

            close () {
                this.dialog = false;
                this.dialogLoading = false;
                this.clean();
            },            
            clean() {
                this.id = "";
                this.lineName = "";                  
                this.partNo = "";
                this.commodity = 0; 
                this.batch = "";
                this.platform = "";
                this.lob = "";
                this.good = 0;
                this.ng = 0;
                this.fr = 0;
                this.defectDescription = "";               
                this.IPQC_Is_Issue = "";
                this.IPQC_Comments = "";
                this.callOuts = "";
                this.owner = "";
                this.status = "";
                this.currentCall = "";
                this.condition = "";                
                this.creator = "";
                this.updaterDate = "";
                this.updater = ""; 

                this.imgBase64 = "";     
                
                this.issueDetails= [];
                this.issuePictures= [];

                this.editedIndex=-1;

            },
            addDetail(data = []) {
                this.issueDetails.push({
                    departmentID:data['departmentID'],
                    status:data['status'],
                    ownerName:data['ownerName'],
                    callSequence:data['callSequence']
                });
            },
            addPicture(data = []) {
                this.issuePictures.push({                    
                    pictureName:data['pictureName'],
                    imgBase64:data['imgBase64'],
                    comments:data['comments']
                });
            },
            save () {
                //if (!this.valid())  {
                //     return;   
                //}
                this.dialogLoading = true;
                if (this.editedIndex > -1) {
                   // Object.assign(this.desserts[this.editedIndex], this.editedItem)
                   //Code for Edit Mode
                   let me=this;
                   axios.put('api/Issues/Update',{                                                   
                        'issueID':me.id,
                        'lineName':me.lineName,
                        'partNo':me.partNo,
                        'commodity': me.commodity,
                        'batch':me.batch,
                        'platform':me.platform,
                        'lob': me.lob,
                        'good':me.good,
                        'ng':me.ng,
                        'fr':me.fr, 
                        'defectDescription':me.defectDescription, 
                        'updater': me.updater    
                    }).then(function(response){
                        me.close();
                        me.listIssues();
                        me.clean();
                    }).catch(function(error){
                        console.log(error);
                    });                   

                } else {
                    //this.desserts.push(this.editedItem)
                    //Code for Save
                   
                   if (this.validar()){
                       return;
                   }

                    var picture = {
                        pictureName:'Imagen01', 
                        imgBase64: this.imgBase64,
                        comments: 'n/a'
                        };

                    this.issuePictures.push(picture);
                        

                    var detailDepartment = {
                        departmentID:1,
                        status:'Open',
                        ownerName:'',
                        callSequence:1
                    };
                    this.issueDetails.push(detailDepartment)
                   

                    let me=this;                   
                    axios.post('api/Issues/Create',{                                                   
                            'lineName': me.lineName,                  
                            'partNo': me.partNo,
                            'commodity': me.commodity, 
                            'batch': me.batch,
                            'platform': me.platform,
                            'lob': me.lob,
                            'good': me.good,
                            'ng': me.ng,
                            'fr': me.fr, 
                            'defectDescription': me.defectDescription,               
                            //'IPQC_Is_Issue': true,
                            'iPQC_Comments': '',
                            'callOuts': 'IPQC',
                            'owner': 'Pending',
                            'status': 'Open',
                            'currentCall': 'IPQC',
                            //condition: '',
                            //createDate: '',
                            'Creator': 'RAFBEL',
                            'issueDetails': me.issueDetails,
                            'issuePictures': me.issuePictures
                            //updaterDate: '',
                            //updater: '',                  
                            //ImgBase64: ''   
                    }).then(function(response){
                        me.close();
                        me.listIssues();
                        me.clean();
                    }).catch(function(error){
                        console.log(error);
                    });
                }               
            },
            validar() {
                 this.valida=0;
                 this.validaMensaje=[];
                 
                 if (!this.partNo){
                     this.validaMensaje.push('Scan  the Part No');
                 }   
                 if (!this.lineName){
                     this.validaMensaje.push('Input the Line Name');
                 }
                  
                 if (this.validaMensaje.length){
                    this.valida=1;
                }                               
                 return this.valida;

            },
        },
    }
</script>